import { render, staticRenderFns } from "./asset_txt.vue?vue&type=template&id=5b477028&scoped=true&lang=pug&"
import script from "./asset_txt.vue?vue&type=script&lang=js&"
export * from "./asset_txt.vue?vue&type=script&lang=js&"
import style0 from "./asset_txt.vue?vue&type=style&index=0&id=5b477028&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b477028",
  null
  
)

export default component.exports